// react
import { type ReactNode } from 'react';

// api
import { useGetSessionQuery } from '@/api/auth-server/authServerApiSlice';

// relative
import {
  SessionAuthContext,
  type SessionAuthContextValue,
} from '../contexts/SessionAuthContext';

/**
 * Fetches the current session once and exposes it app-wide via context,
 * so components can call `useSessionAuth()` instead of each issuing their
 * own `useGetSessionQuery()` call.
 */
export default function AuthProvider({ children }: { children: ReactNode }) {
  const { data: session, isLoading } = useGetSessionQuery();

  const value: SessionAuthContextValue = {
    session,
    isLoading,
    isAuthenticated: Boolean(session?.authenticated),
  };

  return (
    <SessionAuthContext.Provider value={value}>
      {children}
    </SessionAuthContext.Provider>
  );
}
